import React from "react";
import ChangeRecordDetail from "./changeRecordDetail";

import { framework_tool, component_tool } from "@/tool";
const { WizModal } = component_tool

//配置项
let componentName = "positionChangeRecord";

const columns = (self) => {
  return [
    {
      name: "id",
    },
    {
      title: "来源",
      name: "channel",
      dataIndex: "channel",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        initialValue: 'Zk'
      },
      dict: [
        {code: 'Zk', codeName: '企业号'}
      ]
    },
    {
      title: "关联类型",
      name: "dataType",
      dataIndex: "dataType",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: 'select',
        initialValue: 'SyncPosition'
      },
      dict: [
        {code: 'SyncPosition', codeName: '普通岗位'},
        {code: 'SyncNewEnergyPosition', codeName: '新能源岗位'},
      ]
    },
    {
      title: "第三方岗位编码",
      name: "thirdId",
      dataIndex: "thirdId",
      searchItem: {},
      tableItem: {},
      formItem: {},
    },
    {
      title: "岗位名称",
      name: "beforeName",
      dataIndex: "beforeName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "岗位编码",
      name: "beforeCode",
      dataIndex: "beforeCode",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "所属组织",
      name: "beforeOrgList",
      dataIndex: "beforeOrgList",
      tableItem: {
        render: (text) => {
          return <span>{text?.map(item => item?.name).join(",")}</span>;
        }
      },
    },
    {
      title: "移除组织",
      name: "orgName",
      dataIndex: "orgName",
      tableItem: {},
    },
    {
      title: "关联岗位",
      name: "afterName",
      dataIndex: "afterName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "关联岗位编码",
      name: "afterCode",
      dataIndex: "afterCode",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        {code: 0, codeName: '待执行'},
        {code: 1, codeName: '执行中'},
        {code: 2, codeName: '执行成功'},
        {code: 3, codeName: '执行失败'},
      ]
    },
    {
      title: "执行日志",
      name: "errorLog",
      dataIndex: "errorLog",
      tableItem: {},
    },
  ];
};

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['reExecute', 'executionRecord'],
        rowOperateView: [
          {
            key: "reExecute",
            custom: true,
            params: { children: "重新执行" },
            customOnClick: {
              key: "action",
              params: {
                apiKey:"reExecute"
              },
              formatParams: (rows, record, filters, callback) => {
                return { id: record.id }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.state !== 3;
              return { hidden: is, disabled: is }
            }
          },
          {
            key: "executionRecord",
            custom: true,
            params: { children: "执行记录" },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'executionRecord',
                modalParams: {
                  title: '执行记录',
                  style: { minWidth: 800 },
                  diy: (e) => {
                    return <ChangeRecordDetail
                      key={'executionRecord_' + e.record.id + '_' + new Date().getTime()}
                      ref={r => r && r.getWrappedInstance()}
                      {...e}
                    />
                  },
                  width: 700,
                  footer: null,
                },
              }
            }
          },
        ],
        commonOperate: {}
      },
    },
  };
};

const apis = () => {
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@pageList`,
        apiParams: {},
      },
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    reExecute: {
      path: `${componentName}/reExecute`,
      payload: {
        key: `${componentName}@reExecute`,
        apiParams: {}
      }
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
